import { useNavigate } from 'react-router-dom';
import { routes } from '@/routes/routes';
import { useTrackOnboardingCompleted } from '@/lib/tracking';
import { RefinanceBanner } from '../../components/RefinanceBanner';
import styles from './PreliminaryRefinancePage.module.scss';

/**
 * No preliminary offer, rejected on income (debt ratio included): refinancing
 * lowers the rate, see its landing.
 */
export function PreliminaryRefinancePage() {
  const navigate = useNavigate();

  useTrackOnboardingCompleted();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Gradul tău de îndatorare este prea mare 📈
        </h1>
        <p className={styles.description}>
          Refinanțează-ți creditele, obține o rată mai mică și bani în plus.
        </p>
      </div>
      <RefinanceBanner
        trackingId="preliminary_no_offer_refinance"
        onClick={() => navigate(routes.offer.preliminaryRefinanceLanding)}
      />
    </div>
  );
}

export default PreliminaryRefinancePage;
